import {
	BsCreditCard2Front,
	BsGraphUpArrow,
	BsTag
} from "react-icons/bs";

export const apuracaoSummaryCards = [
	{
		key: "open-installments",
		title: "Valor total das parcelas em aberto",
		icon: BsCreditCard2Front,
		iconVariant: "blue",
		monthValue: 500000,
		quarterValue: 1500000
	},
	{
		key: "granted-discounts",
		title: "Valor total de descontos concedidos",
		icon: BsTag,
		iconVariant: "blue",
		monthValue: 300000,
		quarterValue: 900000
	},
	{
		key: "amount-receivable",
		title: "Valor total a receber após descontos",
		icon: BsGraphUpArrow,
		iconVariant: "green",
		monthValue: 200000,
		quarterValue: 600000
	}
];

export const apuracaoHistorySummaryCards = [
	{
		key: "assessed-installments",
		title: "Valor total parcelas apurado",
		icon: BsCreditCard2Front,
		iconVariant: "blue",
		value: 1500000,
		description: "Total apurado"
	},
	{
		key: "granted-discounts-history",
		title: "Valor total de descontos concedidos",
		icon: BsTag,
		iconVariant: "blue",
		value: 900000,
		description: "Total concedido"
	},
	{
		key: "received-after-discounts",
		title: "Valor total recebido após descontos",
		icon: BsGraphUpArrow,
		iconVariant: "green",
		value: 600000,
		description: "Total recebido"
	}
];